import script from "./Store.vue?vue&type=script&setup=true&lang=js"
export * from "./Store.vue?vue&type=script&setup=true&lang=js"

import "./Store.vue?vue&type=style&index=0&id=12af4c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12af4c96"]])

export default __exports__